<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    class="mt-40"
  >
    <el-collapse
      v-model="activeCollapse"
      v-if="teams"
    >
      <el-collapse-item
        class="primary-outline"
        v-for="(team, index) in teams"
        :key="index"
      >
        <template slot="title">
          <div class="title">
            <p class="truncate">
              {{ team.name }}
            </p>
          </div>
        </template>
        <div class="rows-wrapper">
          <div class="row">
            <span class="property">{{ $t("organization.name") }}</span>
            <span class="value truncate">{{ team.name }}</span>
          </div>
          <div class="row">
            <span class="property">{{
              $t("organization.type-sharing-tips.title")
            }}</span>
            <span class="value">{{ team.sharingType }}</span>
          </div>
        </div>
        <div
          style="display: flex; margin-top: 20px; margin-bottom: 20px;"
          v-if="isAdmin"
        >
          <el-button
            type="primary"
            class="primary-button"
            @click="showGenerateSignupLinkModal(team.id)"
          >
            Signup Link
          </el-button>
        </div>
        <el-row>
          <el-col :span="11">
            <router-link
              :to="{
                name: 'EditTeam',
                params: { id: $route.params.id, teamId: team.id },
              }"
              custom
              v-slot="{ navigate }"
            >
              <el-button
                type="primary"
                class="primary-button"
                @click="navigate"
              >
                {{ $t("form.edit") }}
              </el-button>
            </router-link>
          </el-col>
          <el-col
            :offset="2"
            :span="11"
          >
            <router-link
              :to="{
                name: 'Team',
                params: { id: $route.params.id, teamId: team.id },
              }"
              custom
              v-slot="{ navigate }"
            >
              <el-button
                type="primary"
                class="primary-button"
                @click="navigate"
              >
                {{ $t("form.details") }}
              </el-button>
            </router-link>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
    <router-link
      :to="{ name: 'CreateTeam', params: { id: $route.params.id } }"
      custom
      v-slot="{ navigate }"
    >
      <el-button
        type="primary"
        class="primary-button"
        @click="navigate"
      >
        {{ $t("organization.create-team") }}
      </el-button>
    </router-link>
    <generate-signup-link
      v-if="generateSignupLinkDialog"
      :visible.sync="generateSignupLinkDialog"
      :team-id="teamId"
    />
  </div>
</template>

<script>
import authHelpers from "@/plugins/auth-helpers";
import GenerateSignupLink from "./GenerateSignupLink.vue";

export default {
  name: "Teams",
  components: {
    GenerateSignupLink,
  },
  data: () => ({
    fullScreenLoading: true,
    isAdmin: false,
    activeCollapse: [],
    teams: [],
    generateSignupLinkDialog: false,
    teamId: null,
  }),
  methods: {
    showGenerateSignupLinkModal(teamId) {
      this.generateSignupLinkDialog = true;
      this.teamId = teamId;
    },
  },
  created() {
    authHelpers.isCurrentUserAdmin().then((response) => {
      this.isAdmin = response;
    });
    this.$adminApi
      .get("/api/v1/entities/" + this.$route.params.id + "/teams")
      .then((response) => {
        this.teams = response.data;
        this.fullScreenLoading = false;
      })
      .catch(() => {
        this.fullScreenLoading = false;
      });
  },
};
</script>

<style scoped lang="scss"></style>
